import type { InjectionKey } from "vue";
import type { AppContext } from "./app-context";

export const InputGroupSymbol: InjectionKey<boolean> = Symbol("InputGroup");

export const AppContextSymbol: InjectionKey<AppContext> = Symbol("AppContext");
